import React from "react"
import { Spinner } from "components"

import classes from "./PageLoader.module.scss"

const PageLoader = () => (
  <div className={classes["container"]}>
    <Spinner color="var(--color-primary)" size={30} />
  </div>
)
export default PageLoader